/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

import React from 'react'
import {List, ListItem} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'
import Link from '@salesforce/retail-react-app/app/components/link'

// Others
import {noop} from '@salesforce/retail-react-app/app/utils/utils'

/**
 * LinkRefinements is a functional component that renders a list of links based on the provided filter object.
 *
 * @component
 * @param {Object} props - The properties object.
 * @param {Object} props.filter - An object containing filter data, specifically an array of values.
 * @param {Function} [props.onSelect=noop] - An optional callback function that is triggered when a link is clicked.
 *
 * @returns {JSX.Element} A list of links rendered as a column, each linking to a category page.
 */
const LinkRefinements = ({filter, onSelect = noop}) => {
    return (
        <List display="flex" flexDirection="column" gap={10}>
            {filter.values.map((value) => {
                return (
                    <ListItem key={value.value}>
                        <Link href={`/category/${value.value}`} onClick={onSelect} useNavLink>
                            {value.label}
                        </Link>
                    </ListItem>
                )
            })}
        </List>
    )
}

LinkRefinements.propTypes = {
    filter: PropTypes.object,
    onSelect: PropTypes.func
}

export default LinkRefinements
